import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumb with schema.org markup for SEO — sits above the hub H1.
 * Each item: { label, to? } — the last item is rendered as text (current page).
 */
export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="text-sm text-muted-foreground mb-4" data-testid="breadcrumbs">
      <ol
        className="flex items-center flex-wrap gap-1"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          return (
            <li
              key={i}
              className="flex items-center gap-1"
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
            >
              {i > 0 ? <ChevronRight className="w-3 h-3 opacity-60" /> : null}
              {it.to && !isLast ? (
                <Link
                  to={it.to}
                  itemProp="item"
                  className="hover:text-foreground underline-offset-2 hover:underline"
                >
                  <span itemProp="name">{it.label}</span>
                </Link>
              ) : (
                <span itemProp="name" className="text-foreground">
                  {it.label}
                </span>
              )}
              <meta itemProp="position" content={String(i + 1)} />
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
